/* global */
/* eslint-disable */
(function (i, s, o, g, r, a, m) {
    i["GoogleAnalyticsObject"] = r; i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments)
    }, i[r].l = 1 * new Date(); a = s.createElement(o),
        m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
})(window, document, "script", "//www.google-analytics.com/analytics.js", "ga");

window.initHotjar = function(params) {
    !function(h, o, t, j, a, r) {
        h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
        h._hjSettings = { hjid: params.id, hjsv: 6 };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script'); r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
    }(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}
window.initTwitter = function(params) {
    !function (e, n, u, a) {
        e.twq || (a = e.twq = function () {
            a.exe ? a.exe.apply(a, arguments) :
            a.queue.push(arguments);
        }, a.version = '1', a.queue = [], t = n.createElement(u),
            t.async = !0, t.src = '//static.ads-twitter.com/uwt.js', s = n.getElementsByTagName(u)[0],
            s.parentNode.insertBefore(t, s))
    }(window, document, 'script');
    // Insert Twitter Pixel ID and Standard Event data below
    twq('init', params.init);
    twq('track', 'PageView');
}

/* eslint-enable */

/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable guard-for-in */
/* eslint-disable no-loop-func */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */

function GBEAnalytics(options) {

    var t;
    //create each logger
    var allTrackerNameArray = [];
    for (t in options.trackers) {
        allTrackerNameArray.push(t);
        ga("create", {
            trackingId: options.trackers[t],
            cookieDomain: options.domain,
            name: t
        });
        ga(t + ".require", "ecommerce");
    }

    //if empty then used the ones in constructor
    function getTrackersToUse(trackers) {
        if (trackers === undefined) {
            trackers = allTrackerNameArray;
        }
        return trackers;
    }

    this.logExternalLink = function (element, trackers) { //optional trackers
        var url = $(element).attr("href");

        trackers = getTrackersToUse(trackers);

        var params = {
            hitType: "event",
            eventCategory: "general",
            eventAction: "click",
            eventLabel: "link=" + url,
            hitCallback: function () {

                if ($(element).attr("target") !== undefined) {
                    window.open(url, $(element).attr("target"));
                } else {
                    window.location = url;
                }
            }
        };

        for (c = 0; c < trackers.length; c++) {
            if (c < (trackers.length - 1)) {
                delete params.hitCallback;
            }
            ga(trackers[c] + ".send", params);
        }

        return false;
    };

    this.logLink = function (element, p, trackers) { //optionals trackers
        trackers = getTrackersToUse(trackers);
        p = p || {};
        var params = {
            hitType: "event",
            eventCategory: p.eC || p.eventCategory || "general",
            eventAction: p.eA || p.eventAction || "click",
            eventLabel: p.eL || p.eventLabel || "link=" + $(element).attr("id")
        };

        for (c = 0; c < trackers.length; c++) {
            if (c < (trackers.length - 1)) {
                delete params.hitCallback;
            }
            ga(trackers[c] + ".send", params);

        }

        window.location = $(element).attr("href");

        return true;

    };

    this.logECommerceTransaction = function (transaction, items, trackers) {

        var c;
        trackers = getTrackersToUse(trackers);

        for (c = 0; c < trackers.length; c++) {
            ga(trackers[c] + ".ecommerce:addTransaction", transaction);

            //$.each(items, function() {
            //    ga(trackers[c] + ".ecommerce:addItem", this);
            //});
            ga(trackers[c] + ".ecommerce:addItem", items);

            ga(trackers[c] + ".ecommerce:send");
        }

    };

    this.log = function (logParams, trackers) { //options trackers
        var params = {
            hitType: logParams.hT || logParams.hitType || "general",
            eventCategory: logParams.eC || logParams.eventCategory || "general",
            eventAction: logParams.eA || logParams.eventAction || "click",
            eventLabel: logParams.eL || logParams.eventLabel,
            eventValue: logParams.eventValue,
            hitCallback: logParams.hitCallback
        };

        trackers = getTrackersToUse(trackers);

        if (ga.q) {
            if (logParams.hitCallback) {
                logParams.hitCallback();
            }
        }

        for (c = 0; c < trackers.length; c++) {
            if (c < (trackers.length - 1)) {
                delete params.hitCallback;
            }
            ga(trackers[c] + ".send", params);

        }

        return true;
    };

    this.setPage = function (page) {

        for (t in options.trackers) { // sets page for all trackers
            ga(t + ".set", {
                page: page.url,
                title: page.title
            });
        }
    };

    this.setUserId = function (userId) {
        for (t in options.trackers) {
            ga(t + ".set", "userId", String(userId));
        }
    };


    this.logToTwitter = function (event, txn_ids) {
        var myTwitter;
        if ("twttr" in window) { // check if twitter file loaded
            myTwitter = window.twttr;
        }
        if (txn_ids && txn_ids[event] !== undefined && myTwitter && myTwitter.conversion && myTwitter.conversion.trackPid) {
            twttr.conversion.trackPid(txn_ids[event]);
        }

    };
}

function initGoogleAnalytics(trackingId) {

    if (typeof trackingId === "string" || trackingId instanceof String) {
        GBEglobal.logger = new GBEAnalytics({
            trackers: {
                "partner": trackingId
            },
            domain: com.globalbettingexchange.base.getTopDomain()
        });
    } else {
        GBEglobal.logger = new GBEAnalytics({
            trackers: trackingId,
            domain: com.globalbettingexchange.base.getTopDomain()
        });
    }

}


initGoogleAnalytics(configurationSettings.trackingId);